export default {"src":"/_next/static/media/process_icon_1.db8b1fb6.svg","height":70,"width":69};